import Vue from 'vue'
import axios from 'axios'
import Qs from 'qs'
import { isJSON } from '@common/js/common'
import { interceptRequest } from '@common/js/http'

// post请求时需要将Content-Type设置为'application/x-www-form-urlencode',参数才会以form-data形式提交
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

// 设置超时时间
axios.defaults.timeout = 60 * 1000

// 拦截请求，修改请求的配置
axios.interceptors.request.use(
  config => {
    config = interceptRequest(config, Qs)

    // 统计接口用时，发送到ga
    config.transformResponse = data => {
      let data_format = isJSON(data) ? JSON.parse(data) : data

      return data_format
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 拦截响应
axios.interceptors.response.use(response => {
  let data = response.data
  let code = data.c
  switch (code) {
    // 请求成功
    case 0:
      return data.d
    case -3: // 没有权限
    case -6: // 登录过期
      Vue.prototype.Login()
      return Promise.reject(data)
    case -4:
    case -5:
      return Promise.reject(data)
    default:
      return Promise.reject(data)
  }
})

Object.defineProperties(Vue.prototype, {
  $http: {
    get() {
      return axios
    },
  },
})

export { axios as $http }
